import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {makeStyles} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import ReactGA4 from "react-ga4";
import {RWebShare} from "react-web-share"
import axios from "axios";
import {
    useAddressPosition,
    useMarkersPosition,
    useQueryParameters,
} from "../utils/recoil";
import InputName from "./InputName";


export default function ButtonGroup() {
    const {t} = useTranslation()
    const [markers, setMarkers] = useMarkersPosition();
    const [address, setAddress] = useState(JSON.parse(sessionStorage.getItem("address")));
    const [query, setQuery] = useQueryParameters();
    const [email, setEmail] = useState("");
    let history = useHistory();

    function handleClick() {
        history.push("/");
        ReactGA4.event({category: 'event', action: 'back2address'})
    }

    function handleEmailChange(email) {
        if (email.length > 4) {
            setEmail(email);
        }
    }

    const token = "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJKT3dZN0JlbkZJc3RDUjRKdk1NLVkzMDdBTU5wQTY5WXByVFhSOXJWd21jIn0.eyJleHAiOjE3NDc5MDQxNTAsImlhdCI6MTcxNjgwMDE1MCwianRpIjoiNmYyMmNmMzYtNmM3ZC00OTA3LTliMDctYTgxM2FmNTM0NDEzIiwiaXNzIjoiaHR0cHM6Ly9rZXljbG9hay5rYXNrbzJnby5vcmcvcmVhbG1zL2JhbGNpYS1ycnIiLCJzdWIiOiI2MGI0Yzc1OS0yZDFhLTQxMWQtOWZjMS0xMmFkMGRlZGViNjgiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJhZG1pbi1jbGkiLCJzZXNzaW9uX3N0YXRlIjoiZDIzNTI1MzUtZDAxYy00NTM2LWE5MzYtNjM1ZmViZTZlYTJmIiwiYWNyIjoiMSIsInNjb3BlIjoiZW1haWwgcHJvZmlsZSIsInNpZCI6ImQyMzUyNTM1LWQwMWMtNDUzNi1hOTM2LTYzNWZlYmU2ZWEyZiIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJuYW1lIjoiQmFsY2lhIENvcnBvcmF0aXZlIEFjY291bnQiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJiYWxjaWEtcnJyIiwiZ2l2ZW5fbmFtZSI6IkJhbGNpYSIsImZhbWlseV9uYW1lIjoiQ29ycG9yYXRpdmUgQWNjb3VudCIsImVtYWlsIjoiYmFsY2lhQGthc2tvbzJnby5vcmcifQ.d7qOutjN8AJ1UYEhuNRswP4-rSG9juNeT4L0Nbt_Sn-_gS0CDDXdE8rRS1XLSxnPDO_ojVJhxcDmLHqTkYbOKDRnm6liKav3sos4wyZ65VBrQ8uZbcu3duW-g3-S-NQaD92hNYnM8JSHN1EZFbi1Lcyk5hVkc9K2OsEbZ2pChtUUXPaWHZ_XiVaE7czyS-mWdUlhFiNewF8fnTx66xRJ0iYPuPSCAjNApAtGSGrrNG6akSVbeV6La9v7gnyVjz_YuO3MWDVkL1uXXpslz0Lz8ZgUrsIHpYaq5t3QFVkWwP0byR5vytcDHYesV1lfG_PAUwrQEEeG_xu7Wbuxpp_gmg"

    return (<>
        <div className="body3BlockButton">
            <div className="image-wrapper">
                <div className="subTitleButtonGroup">
                    {t("another_subtitle")}
                </div>
                <div>
                    <Button variant="contained" className="buttonRRR" onClick={handleClick}>
                        <span className="buttonRRRColor">{t("another_btn")}</span>
                    </Button>
                </div>
            </div>
        </div>
    </>)
};

